import { PanelLeft, PanelLeftClose, X } from 'lucide-react'
import { cn } from '../../lib/utils'
import { BrandLogo } from '../shared/brand-logo'

export function CollapsedContextualSidebar({
  isDark,
  onExpand,
}: {
  isDark: boolean
  onExpand: () => void
}) {
  return (
    <aside
      aria-label="Document navigation"
      className={cn(
        'flex w-10 flex-col items-center border-r py-3',
        isDark ? 'border-white/[0.06] bg-surface-1' : 'border-neutral-200 bg-white',
      )}
    >
      <button
        type="button"
        onClick={onExpand}
        className={cn(
          'cursor-pointer rounded-md p-1.5',
          isDark
            ? 'text-neutral-500 hover:bg-surface-3 hover:text-neutral-300'
            : 'text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700',
        )}
        title="Expand document navigation"
        aria-label="Expand document navigation"
      >
        <PanelLeft className="h-4 w-4" aria-hidden="true" />
      </button>
    </aside>
  )
}

export function ContextualSidebarHeader({
  isDark,
  isMobile,
  onCollapse,
  onClose,
}: {
  isDark: boolean
  isMobile: boolean
  onCollapse: () => void
  onClose: () => void
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between border-b px-3 py-3',
        isDark ? 'border-white/[0.06]' : 'border-neutral-200',
      )}
    >
      <BrandLogo size="xs" />
      <button
        type="button"
        onClick={isMobile ? onClose : onCollapse}
        className={cn(
          'cursor-pointer rounded-lg p-2 md:p-1',
          isDark
            ? 'text-neutral-500 hover:bg-surface-3 hover:text-neutral-300'
            : 'text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700',
        )}
        title={isMobile ? 'Close document navigation' : 'Collapse document navigation'}
        aria-label={isMobile ? 'Close document navigation' : 'Collapse document navigation'}
      >
        {isMobile ? (
          <X className="h-5 w-5" aria-hidden="true" />
        ) : (
          <PanelLeftClose className="h-4 w-4" aria-hidden="true" />
        )}
      </button>
    </div>
  )
}
